export const ruTranslations = {
  common: {
    login: "Войти",
    email: "Email",
    password: "Пароль",
    loading: "Загрузка...",
    cancel: "Отмена",
    submit: "Отправить",
    delete: "Удалить",
    close: "Закрыть",
    copy: "Копировать",
    copied: "Скопировано!",
    status: "Статус",
    active: "Активный",
    fulfilled: "Использован",
    expired: "Истек",
    deleting: "Удаление...",
    creating: "Создание...",
    updating: "Обновляем...",
    actions: "Действия",
    name: "Название",
    description: "Описание",
    id: "ID",
    invalidEmail: "Пожалуйста, введите действительный адрес электронной почты",
    invalidMaxUses:
      "Пожалуйста, введите корректное максимальное количество использований",
    isRequired: "обязательно",
    back: "Назад",
    notAvailable: "Недоступно",
    add: "Добавить",
    search: "Поиск...",
    noResultsFound: "Ничего не найдено",
    save: "Сохранить",
    remove: "Удалить",
    view: "Просмотр",
    createdAt: "Дата создания",
    runTest: "Запустить тест",
    testing: "Тестирование",
    retry: "Повторить",
    create: "Создать",
  },
  invitations: {
    invitations: "Приглашения",
    createInvitation: "Создать Приглашение",
    noInvitationsFound: "Приглашения не найдены.",
    loadingInvitations: "Загрузка приглашений...",
    failedToLoadInvitations:
      "Не удалось загрузить приглашения. Пожалуйста, попробуйте снова.",
    failedToCreateInvitation:
      "Не удалось создать приглашение. Пожалуйста, попробуйте снова.",
    enterEmailAddress: "Введите адрес электронной почты",
    enterMaxUses: "Введите макс. число использований (по умолчанию: 1)",
    organization: "Организация",
    role: "Роль",
    expiresIn: "Срок действия",
    deleteInvitation: "Удалить приглашение",
    deleteInvitationConfirm: "Вы уверены, что хотите удалить приглашение для",
    failedToDeleteInvitation:
      "Не удалось удалить приглашение. Пожалуйста, попробуйте снова.",
    invitationCreatedSuccess: "Токен приглашения успешно создан!",
    yourToken: "Ваш токен",
    token: "Токен",
    expiresAt: "Истекает",
    maxUses: "Макс. исп.",
    usageCount: "Исп.",
    createdBy: "Создатель",
    day1: "1 День",
    days3: "3 Дня",
    days7: "7 Дней",
    days30: "30 Дней",
  },
  dashboard: {
    dashboard: "Панель управления",
    welcomeDashboard:
      "Добро пожаловать в панель управления Grensa. Управляйте вашей командой, базой знаний и настройками.",
    manageTeam: "Управление командой",
    manageTeamDesc:
      "Приглашайте и управляйте участниками команды для совместной работы с базой знаний.",
    manageInvitations: "Управление приглашениями",
    knowledgeBase: "База знаний",
    knowledgeBaseDesc:
      "Добавляйте и управляйте источниками базы знаний для лучшей поддержки клиентов.",
    settings: "Настройки",
    settingsDesc: "Настройте параметры вашего аккаунта и предпочтения.",
    comingSoon: "Скоро",
  },
  roles: {
    user: "Пользователь",
    admin: "Администратор",
    superAdmin: "Супер Администратор",
  },
  organizations: {
    organizations: "Организации",
    organization: "Организация",
    createOrganization: "Создать организацию",
    editOrganization: "Редактировать организацию",
    updateOrganization: "Обновить организацию",
    noOrganizationsFound: "Организации не найдены.",
    loadingOrganizations: "Загрузка организаций...",
    failedToCreateOrganization: "Не удалось создать организацию.",
    failedToUpdateOrganization: "Не удалось обновить организацию.",
    enterOrganizationName: "Введите название организации",
    enterOrganizationDescription: "Введите описание организации",
    selectOrganization: "Выберите организацию",
  },
  logs: {
    logs: "Логи",
    answers: "Ответы",
    knowledgeBaseIngestions: "Загрузки базы знаний",
    answerId: "ID ответа",
    chatId: "ID чата",
    userId: "ID пользователя",
    userName: "Пользователь",
    orgName: "Организация",
    createdAt: "Создано",
    status: "Статус",
    tokens: "Токены",
    cost: "Стоимость",
    searchByAnswerId: "Поиск по ID ответа",
    searchByUserEmail: "Поиск по email пользователя",
    searchByOrganization: "Поиск по организации",
    searchMode: "Режим поиска",
    filterOrganizations: "Фильтр организаций...",
    selectOrganization: "Выберите организацию",
    resultsCount: "Результаты: {{count}}",
    noResults: "Результаты не найдены",
    loading: "Загрузка...",
    ingestionId: "ID загрузки",
    documentName: "Название документа",
    date: "Дата",
    size: "Размер",
    searchByDocumentName: "Поиск по названию документа",
    answerDetails: "Детали ответа",
    answerDetailsPlaceholder: "Здесь будут отображаться детали ответа",
    summary: "Резюме",
    question: "Вопрос",
    answer: "Ответ",
    sources: "Источники",
    definition: "Определение",
    search: "Поиск",
    validation: "Валидация",
    request: "Запрос",
    noConversationData: "Данные беседы недоступны",
    noSummary: "Резюме недоступно",
    noQuestion: "Вопрос недоступен",
    noAnswer: "Ответ недоступен",
    noSources: "Источники недоступны",
    noError: "Ошибка отсутствует",
    noStatus: "Статус недоступен",
    prompt: "Запрос",
    response: "Ответ",
    model: "Модель",
    totalTokens: "Всего токенов",
    noLogData: "Данные лога недоступны",
    promptTokens: "Токены запроса",
    completionTokens: "Токены ответа",
    rawData: "Необработанные данные",
    formattedData: "Форматированные данные",
    developer: "Разработчик",
    user: "Пользователь",
    language: "Язык",
    relevantSections: "Релевантные разделы",
    error: "Ошибка",
    currentQuestion: "Текущий вопрос",
    clientQuestion: "Вопрос клиента",
    candidateQuestions: "Кандидаты вопросов",
    conversation: "Разговор",
    product: "Продукт",
    macrosSuggestions: "Предложенные макросы",
    macros: "Макросы",
    macroTitle: "Название",
    macroText: "Текст",
    macroQuestions: "Вопросы",
    macroSimilarity: "Схожесть",
    macroProduct: "Продукт",
    macroId: "ID макроса",
    selectedMacro: "Выбранный макрос",
    fromSearch: "из поиска",
    fromSuggestion: "из предложений",
  },
  status: {
    successful: "Успешно",
    unsuccessful: "Неуспешно",
    undecided: "Не определено",
    completed: "Завершено",
    failed: "Не удалось",
    pending: "В процессе",
  },
  errors: {
    failedToFetchAnswers:
      "Не удалось загрузить ответы. Пожалуйста, попробуйте еще раз.",
    failedToFetchAnswerLogs:
      "Не удалось загрузить логи ответа. Пожалуйста, попробуйте еще раз.",
    failedToProcessData:
      "Не удалось обработать данные. Пожалуйста, попробуйте еще раз.",
    failedToProcessLogs:
      "Не удалось обработать данные логов. Пожалуйста, попробуйте еще раз.",
    failedToGetAnswerId: "Не удалось получить ID ответа из ответа сервера.",
    connectionError:
      "Ошибка соединения. Пожалуйста, проверьте подключение и попробуйте снова.",
    errorOccurred: "Произошла ошибка",
    pageNotSupported: "Этот тип страницы не поддерживается",
    noQuestion:
      "У клиента нет вопросов в данный момент или на все вопросы уже даны ответы.",
    noRelevantWikisError:
      "Релевантной статьи не найдено в базе знаний. При необходимости, добавте статьи относящиеся к данному чату в базу знаний.",
  },
  pagination: {
    showing: "Отображается {{from}} - {{to}} из {{total}} записей",
  },
  test: {
    testPage: "Тестирование",
    blockTestPage: "Блочное тестирование",
    multiChatTestPage: "Мульти-чат тест",
    addClientMessage: "Добавить сообщение клиента",
    addAgentMessage: "Добавить сообщение агента",
    clientMessagePlaceholder: "Введите сообщение клиента здесь...",
    agentMessagePlaceholder: "Введите сообщение агента поддержки здесь...",
    testAnswerGeneration: "Тестирование генерации ответов",
    generateAnswer: "Сгенерировать ответ",
    clearConversation: "Очистить диалог",
    noMessagesToProcess:
      "Нет сообщений для обработки. Пожалуйста, добавьте хотя бы одно сообщение.",
    generatingAnswer: "Генерация ответа...",
    fetchingLogs: "Загрузка данных логов...",
    addNewChat: "Добавить новый чат",
    addFirstChat: "Добавить первый чат",
    chatName: "Название чата",
    enterChatName: "Введите название чата",
    conversationMessages: "Сообщения диалога",
    noChatsAdded:
      "Пока не добавлено ни одного чата. Начните с добавления первого чата.",
    runTest: "Запустить тест",
    runningTest: "Запуск теста...",
    testCardName: "Тест #{{number}}",
    createBlockTest: "Создать блочный тест",
    blockTestPageDescription:
      "Тестирование нескольких чатов с разными сценариями для организации",
    createNewBlockTest: "Создать новый блочный тест",
    noBlockTestsAvailable:
      "Блочные тесты отсутствуют. Начните с создания первого теста.",
    createFirstBlockTest: "Создать первый блочный тест",
    blockTestName: "Название блочного теста",
    enterBlockTestName: "Введите название теста",
    testChats: "Тестовые чаты",
    chatCount: "Чаты",
    organization: "Организация",
    aiResponse: "Ответ ИИ",
    aiResponseError: "Ошибка ответа ИИ",
    noQuestionError:
      "У клиента нет вопросов в данный момент или на все вопросы уже даны ответы.",
    noRelevantWikisError:
      "Релевантной статьи не найдено в базе знаний. При необходимости, добавте статьи относящиеся к данному чату в базу знаний.",
    genericServerError:
      "Произошла серверная ошибка. Пожалуйста, попробуйте позже.",
    markSuccessful: "Отметить как успешный",
    markUnsuccessful: "Отметить как неуспешный",
    viewFullDetails: "Посмотреть полные детали",
    resetTests: "Сбросить тесты",
    rerunTest: "Перезапустить тест",
    addMoreChats: "Добавить еще чаты",
    confirmResetTests:
      "Вы уверены, что хотите сбросить все тесты? Это очистит все чаты и результаты.",
    viewBlockTest: "Блочный тест #{{id}}",
    summary: "Резюме ответа",
    copyChatCard: "Копировать карточку чата",
    numberOfCopies: "Количество копий",
  },
  validation: {
    chatNameRequired: "Требуется название чата",
  },
};

export default ruTranslations;
